import angular from 'angular';

const app = angular.module(MyGlobal.page.ngAppName);

import './feedReDropPopup.less';

if (MyGlobal.project.isMobile) {
    import('./feedReDropPopup_mobile.less');
}

app.controller('MyFeedReDropPopup', ($scope, $uibModalInstance, $timeout,
                                     $rootScope, analyticsService, popupParams) => {
    const { feedDrop } = popupParams;
    $scope.feedDrop = feedDrop;

    $scope.onReDropCreated = (feedDrop) => {

        $rootScope.$broadcast('feedDrop:created', feedDrop);
        $rootScope.$broadcast('feedDrop:redroped', feedDrop.originalFeedDrop);
        $rootScope.$broadcast(`feedDrop:redroped:${feedDrop.originalFeedDrop._id}`);

        analyticsService.trackFeedEvent({
            eventAction: 'redrop'
        });

        $scope.close();
    }

    $scope.close = () => {
        $uibModalInstance.dismiss();
    };

    $timeout(()=> {
        if (!$scope.feedDrop) {
            $scope.close();
        }
    });
});
